import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { DecimalHelper } from "@/helpers";
import { useAppDispatch, useAppSelector } from "@/stores";
import {
  tenantDailyReportDepositSelects,
  tenantDailyReportDepositThunks,
} from "./store";
// components
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { ReportDepositItem } from "@/domains/report";

export const TenantDailyReportDepositListPage = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const loading = useAppSelector(tenantDailyReportDepositSelects.loading);

  const items = useAppSelector(tenantDailyReportDepositSelects.items);

  useEffect(() => {
    void dispatch(tenantDailyReportDepositThunks.list());
  }, [dispatch]);

  const columns: ColumnsType<ReportDepositItem> = [
    {
      width: 100,
      title: t("domains.Report.date"),
      dataIndex: "date",
    },
    {
      width: 100,
      title: t("domains.Report.recordCount"),
      align: "right",
      key: "count",
      render(_, { count }) {
        return <div className="t:right">{DecimalHelper.locale(count)}</div>;
      },
    },
    {
      width: 150,
      title: t("domains.Report.resultTotalUnit"),
      align: "right",
      key: "result",
      render(_, { result }) {
        return <div className="t:right">{DecimalHelper.locale(result)}</div>;
      },
    },
    {
      width: 150,
      title: t("domains.Report.resultTotalAmount"),
      align: "right",
      key: "result0",
      render(_, { result0 }) {
        return <div className="t:right">{DecimalHelper.locale(result0)}</div>;
      },
    },
    {
      width: 150,
      title: t("domains.Report.totalCharge"),
      align: "right",
      key: "charge",
      render(_, { charge }) {
        return <div className="t:right">{DecimalHelper.locale(charge)}</div>;
      },
    },
    {
      title: "",
      render() {
        return <div className="t:right"></div>;
      },
    },
  ];

  return (
    <div className="flex flex:col gap:8">
      <Table
        rowKey="id"
        tableLayout="fixed"
        loading={loading}
        columns={columns}
        dataSource={items}
        scroll={{ x: "1600px" }}
      ></Table>
    </div>
  );
};
